module.exports = __webpack_public_path__ + "static/img/suggestion-bg.4c7c0d5e.png";